import App from '../components/app/App';

function main() {
  new App('#app');
}

main();
